import React from "react";

export default function GuestBrokerSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="248"
      height="200"
      viewBox="0 0 248 200"
      fill="none"
    >
      <g clipPath="url(#9i7zueo3ua)">
        <path
          d="M197.564 36.43c-1.281 14.114-4.93 28.997-10.654 43.356-7.077 17.758-16.747 33.398-27.964 45.231l-.623-.543c11.163-11.776 20.789-27.347 27.837-45.031 6.37-15.98 10.158-32.611 10.961-48.086l.796.133a127.609 127.609 0 0 1-.353 4.94zM202.666 118.401c-15.755 25.066-34.869 42.975-53.822 50.428l-.383-.703c18.821-7.402 37.824-25.219 53.507-50.17l.698.445z"
          fill="#E5E9EB"
        />
        <path
          d="M197.181 54.003c-1.281 14.114-4.93 28.996-10.654 43.356-7.077 17.757-16.747 33.398-27.964 45.231l-.623-.543c11.163-11.776 20.789-27.348 27.837-45.032 6.37-15.98 10.159-32.61 10.962-48.085l.795.133a125.68 125.68 0 0 1-.353 4.94z"
          fill="#E5E9EB"
        />
        <path
          d="M20.311 90.238H9.974a1.462 1.462 0 0 1-1.428-1.13 1.433 1.433 0 0 1-.001-.641c.985-4.344.923-8.86-.18-13.176a1.465 1.465 0 0 1 .568-1.54c5.316-3.823 9.502-3.712 12.442.33.133.185.22.397.257.621.786 4.724.83 9.54.13 14.277a1.46 1.46 0 0 1-1.45 1.259z"
          fill="#E5E7E8"
        />
        <path
          d="M17.107 79.886h-3.556a.741.741 0 0 1 0-1.483h3.556a.741.741 0 0 1 0 1.483zM17.107 82.486h-3.556a.742.742 0 0 1 0-1.483h3.556a.741.741 0 0 1 0 1.483zM17.107 85.086h-3.556a.742.742 0 0 1 0-1.483h3.556a.741.741 0 0 1 0 1.483z"
          fill="#fff"
        />
        <path
          d="M208.18 136.392h-10.338a1.466 1.466 0 0 1-1.428-1.13 1.43 1.43 0 0 1-.001-.641c.985-4.344.923-8.86-.18-13.175a1.47 1.47 0 0 1 .568-1.54c5.316-3.823 9.502-3.712 12.442.33.133.184.221.396.258.62a46.01 46.01 0 0 1 .128 14.278 1.461 1.461 0 0 1-1.449 1.258z"
          fill="#E5E7E8"
        />
        <path
          d="M204.975 126.04h-3.556a.741.741 0 0 1 0-1.483h3.556a.742.742 0 0 1 0 1.483zM204.975 128.64h-3.556a.74.74 0 0 1-.524-1.265.745.745 0 0 1 .524-.218h3.556a.743.743 0 0 1 .524 1.266.742.742 0 0 1-.524.217zM204.975 131.241h-3.556a.743.743 0 0 1 0-1.483h3.556a.742.742 0 0 1 0 1.483z"
          fill="#fff"
        />
        <path
          d="M247.295 199.613a.377.377 0 0 1-.113.274.377.377 0 0 1-.274.113H1.091a.389.389 0 0 1-.387-.387.386.386 0 0 1 .387-.386h245.817a.377.377 0 0 1 .274.113.367.367 0 0 1 .084.125.398.398 0 0 1 .029.148z"
          fill="#BDC2C5"
        />
        <path
          d="m65.55 175.931-.645-8.967a29.016 29.016 0 0 0-13.619-3.054c6.641 5.134 6.11 15.393 10.708 22.414a17.44 17.44 0 0 0 13.01 7.711l5.527 3.179a29.239 29.239 0 0 0-6.807-23.514 28.233 28.233 0 0 0-5.32-4.679c-1.208 3.468-2.855 6.91-2.855 6.91zM182.451 177.231l.645-8.967a29.014 29.014 0 0 1 13.618-3.054c-6.641 5.134-6.109 15.393-10.708 22.414a17.444 17.444 0 0 1-13.01 7.711l-5.527 3.179A29.229 29.229 0 0 1 174.276 175a28.254 28.254 0 0 1 5.32-4.679c1.208 3.468 2.855 6.91 2.855 6.91z"
          fill="#E5E9EB"
        />
        <path
          d="M121.074 76.038a6.176 6.176 0 1 0 0-12.351 6.176 6.176 0 0 0 0 12.351z"
          fill="#09BF81"
        />
        <path
          d="M124.244 67.29a.497.497 0 0 0-.689 0 20.465 20.465 0 0 0-3.504 3.579l-.749-1.45c-.289-.557-1.13-.065-.842.493l1.095 2.12a.49.49 0 0 0 .421.236.495.495 0 0 0 .421-.237 19.75 19.75 0 0 1 3.847-4.052.49.49 0 0 0 0-.69z"
          fill="#fff"
        />
        <path
          d="M93.442 87.375 84.129 72.75l10.784-5.776 2.83 11.159 19.942 10.776a4.315 4.315 0 0 1 4.586 1.086 4.313 4.313 0 1 1-7.04 4.78l-21.79-7.4z"
          fill="#790202"
        />
        <path
          d="M77.326 55.209C74.4 59.505 84.798 75.12 84.798 75.12c.507-1.092 5.35 11.17 6.16 10.446 2.305-2.06 5.914-7.794 7.92-8.05 1.147-.145-2.66-8.28-2.66-8.28s-1.74-4.804-4.102-10.94a11.02 11.02 0 0 0-8.004-7s-3.86-.385-6.786 3.912z"
          fill="#8D9DA7"
        />
        <path d="M77.468 195.178h4.422l2.104-17.06-6.527.001v17.059z" fill="#790202" />
        <path
          d="M76.34 193.734h1.245l4.86-1.977 2.605 1.977a5.55 5.55 0 0 1 5.55 5.55v.181H76.34v-5.731z"
          fill="#002035"
        />
        <path d="M98.015 195.178h4.423l2.104-17.06-6.527.001v17.059z" fill="#790202" />
        <path
          d="M96.888 193.734h1.245l4.86-1.977 2.605 1.977a5.55 5.55 0 0 1 5.551 5.55v.181H96.888v-5.731zM99.93 101.914l-28.768.719c-5.463 2.968-5.546 9.391-3.756 17.016 0 0-.605 4.533.604 5.742 1.209 1.208 1.813 1.208 1.209 3.323-.605 2.116 2.588 5.57 2.2 5.958-.387.388-1.294 2.503-1.294 2.503l3.022 17.224s2.115 29.914 2.72 30.518c.604.605 1.208 0 .604 1.511-.605 1.511-1.209.907-.605 1.511.536.577 1.04 1.182 1.511 1.813h7.306s.55-3.022.55-3.324c0-.302.605-2.115.605-2.417 0-.302-.534-.836-.534-.836a9.95 9.95 0 0 1-.373-1.884c0-.604-1.813-23.871-1.813-23.871l3.626-30.216 8.763 29.612s0 25.986.605 26.591c.604.604.604.302.302 1.51-.302 1.209-1.511.907-.605 1.813.907.907 1.21-.604.907.907l-.302 1.511 9.065.129s1.208-2.547.604-3.453c-.604-.907-.568-.659.169-2.143.738-1.483 1.04-1.785.738-2.087-.303-.303-.303-1.91-.303-1.91l-1.51-28.911s-.303-30.519-.303-31.426a3.034 3.034 0 0 1 .251-1.359v-1.231l-1.157-4.36-4.038-10.483z"
          fill="#002035"
        />
        <path
          d="M82.65 42.096a8.938 8.938 0 1 0 0-17.876 8.938 8.938 0 0 0 0 17.876z"
          fill="#790202"
        />
        <path
          d="M87.118 48.004c1.926 1.145 3.078 3.248 3.739 5.389a51.067 51.067 0 0 1 2.194 12.2l.698 12.397 8.65 26.397c-7.496 6.344-35.675 1.442-35.675 1.442s-.865-.288 0-1.153 1.707-.099.842-.964c-.865-.865-.268.099.02-.766.288-.865 0-.289-.288-.577-.289-.288 2.232-2.883 2.232-2.883l-2.307-15.153L64.34 53.77c3.46-4.324 10.418-6.874 10.418-6.874l1.798-3.236 8.99.719 1.572 3.625z"
          fill="#8D9DA7"
        />
        <path
          d="M90.017 28.41a4.142 4.142 0 0 1 1.471 2.066c.1-1.35.107-2.705.02-4.056-.106-.949-.774-1.162-1.548-1.41-.699-.223-1.49-.476-1.702-1.397-2.81-2.733-7.7-2.596-11.048-1.642-1.842.524-2.902 1.198-2.996 1.593l-.02.082-.075.037c-1.42.71-1.696 2.952-1.678 4.707.035 3.308 1.177 7.064 1.82 7.37.034.015.043.009.058-.003.968-.774 2.15.059 2.67.511a9.297 9.297 0 0 1 8.323-7.885 14.584 14.584 0 0 0 2.007-.336 4.224 4.224 0 0 1 1.025-.135c.595-.009 1.179.165 1.673.497z"
          fill="#002035"
        />
        <path
          d="m145.504 109.036 17.194-17.46 4.53-13.964-7.29-2.949c-3.611 3.643-7.328 14.794-7.328 14.794l-11.736 15.75a3.485 3.485 0 0 0-2.251 2.898 3.471 3.471 0 0 0 4.739 3.586 3.479 3.479 0 0 0 2.142-2.655z"
          fill="#FEDBDB"
        />
        <path
          d="m157.95 76.26 9.219 2.667.034-.006c3.389-.658 6.07-6.29 7.722-10.898a6.371 6.371 0 0 0-3.451-7.982 6.38 6.38 0 0 0-6.661 1.016l-4.597 3.958-2.266 11.246z"
          fill="#FC4C4C"
        />
        <path d="M150.063 194.659h-4.958l-2.359-19.123h7.317v19.123z" fill="#FEDBDB" />
        <path
          d="M151.327 193.04h-1.395l-5.448-2.215-2.92 2.215h-.001a6.223 6.223 0 0 0-6.222 6.222v.202l15.986.001v-6.425z"
          fill="#002035"
        />
        <path d="M172.062 194.659h-4.958l-2.359-19.123h7.318l-.001 19.123z" fill="#FEDBDB" />
        <path
          d="M173.326 193.04h-1.395l-5.448-2.215-2.92 2.215h-.001a6.223 6.223 0 0 0-6.222 6.222v.202l15.986.001v-6.425zM179.621 112.288s.579 6.947-.868 13.605c-1.448 6.658-1.448 25.408-1.448 25.408l-3.184 36.537-9.552-.869-2.605-61.076-9.263 20.552.869 2.894-1.157.724s.867 5.644.288 5.644-2.026.869-2.026.869l1.158 29.814-9.842-.289-3.473-41.972 3.763-24.025.289-4.632 1.303.054.663-1.935 1.218-3.329 33.867 2.026z"
          fill="#002035"
        />
        <path
          d="m180.122 113.748.052-.073c2.755-3.857-1.389-13.127-2.014-14.47l2.632-.855-.592-5.038-.281-2.247 2.012-2.012.005-.05 1.158-10.131 1.684-6.73a14.775 14.775 0 0 0-4.193-14.316l-3.892-3.67-4.729-6.997h-7.626l-2.615 4.94a11.114 11.114 0 0 0-8.601 11.349l.593 12.954-2.32 16.129-.001 2.919-2.611 2.901.57 2.851-1.987.852-.878 4.094c-.363.479-2.759 3.675-2.759 4.548 0 .131.096.258.304.399 1.633 1.106 10.661 3.361 14.657 1.762 4.256-1.702 21.174.851 21.344.877l.088.014z"
          fill="#FC4C4C"
        />
        <path
          d="M167.166 44.9c5.578 0 10.1-4.521 10.1-10.1 0-5.578-4.522-10.1-10.1-10.1-5.579 0-10.101 4.522-10.101 10.1 0 5.579 4.522 10.1 10.101 10.1z"
          fill="#FEDBDB"
        />
        <path
          d="M166.198 45.064a27.459 27.459 0 0 0 4.663-.447c1.524-.351 4.885-2.95 5.801-4.485.68-1.141 1.089-2.905 1.312-4.185a12.298 12.298 0 0 0-2.399-9.69 3.878 3.878 0 0 0-1.601-1.296 1.922 1.922 0 0 0-.174-.053 4.787 4.787 0 0 1-2.418-1.412 3.953 3.953 0 0 0-.406-.397 5.896 5.896 0 0 0-2.491-1.171c-1.472-.354-3.578.09-6.258 1.318-1.347.617-2.841.445-3.993.226a.378.378 0 0 0-.35.13 2.649 2.649 0 0 1-1.78.763c-.409.029-.824.607-1.324 1.36-.114.17-.246.37-.342.491l-.02-.228-.225.261a3.223 3.223 0 0 0-.638 3.034 3.208 3.208 0 0 0 2.223 2.16 6.27 6.27 0 0 0 1.265.168c.258.017.525.034.782.072a4.843 4.843 0 0 1 3.679 3.049 1.264 1.264 0 0 0 1.398.79c.191-.034.372-.11.529-.225a2.09 2.09 0 0 1 1.897-.396c.282.147.505.388.632.68.153.326.399.598.707.784 1.052.508 1.184 2.876.863 4.862-.31 1.914-.985 3.31-1.641 3.395-.505.065-.562.103-.596.193l-.031.081.059.074c.282.094.582.126.877.094z"
          fill="#002035"
        />
        <path
          d="m157.819 77.34-4.855-6.185c-4.945 1.362-13.72 9.183-13.72 9.183l-18.02 7.82a3.47 3.47 0 1 0 2.109 5.625l23.606-6.586 10.88-9.856z"
          fill="#FEDBDB"
        />
        <path
          d="m156.655 78.755 7.66-8.54.426-6.05a6.385 6.385 0 0 0-3.168-5.948 6.371 6.371 0 0 0-8.462 2.006c-2.706 4.08-5.618 9.595-4.12 12.704l.015.032 7.649 5.796z"
          fill="#FC4C4C"
        />
        <path
          d="m86.05 110.852-19.909-10.197c-1.416-.725-1.885-2.649-1.046-4.288L78.078 71.02c.84-1.64 2.675-2.383 4.09-1.658l19.91 10.197c1.417.725 1.886 2.649 1.046 4.288l-12.981 25.347c-.84 1.639-2.675 2.383-4.091 1.658z"
          fill="#E5E7E8"
        />
        <path
          d="m82.648 106.164-13.526-6.927c-1.327-.68-1.766-2.481-.98-4.017l10.785-21.058c.786-1.535 2.505-2.231 3.831-1.552l16.338 8.367c1.326.68 1.766 2.481.979 4.016l-5.858 11.44c-3.503 6.839-5.66 12.757-11.569 9.731z"
          fill="#fff"
        />
        <path
          d="m89.337 94.664-11.981-6.136a.75.75 0 0 1 .675-1.32l11.981 6.137a.75.75 0 0 1-.675 1.32zM78.755 92.536l-2.734-1.4a.75.75 0 0 1 .675-1.32l2.735 1.4a.75.75 0 0 1-.676 1.32zM82.261 97.624l-7.576-3.88a.75.75 0 0 1 .676-1.32l7.576 3.88a.75.75 0 0 1-.676 1.32zM94.078 85.407l-11.981-6.136a.75.75 0 0 1 .676-1.32l11.98 6.136a.75.75 0 0 1-.675 1.32zM83.496 83.279l-2.734-1.4a.75.75 0 0 1 .676-1.32l2.734 1.4a.75.75 0 0 1-.676 1.32zM87.003 88.366l-7.577-3.88a.75.75 0 0 1 .676-1.32l7.577 3.88a.75.75 0 0 1-.676 1.32z"
          fill="#FC4C4C"
        />
        <path
          d="M69.552 88.785 65.055 72.04l12.02-2.275-.647 11.493L92.22 97.52a4.311 4.311 0 1 1-4.1 4.86L69.552 88.785z"
          fill="#790202"
        />
        <path
          d="M63.825 53.266c-4.08 3.22 1.156 21.236 1.156 21.236.811-.89 1.753 12.26 2.744 11.813 2.817-1.273 7.979-5.661 9.969-5.303 1.138.204-.054-8.698-.054-8.698s-.22-5.105-.632-11.667a11.02 11.02 0 0 0-5.536-9.078s-3.567-1.524-7.647 1.697z"
          fill="#8D9DA7"
        />
        <path
          d="m131.709 125.951-10.865-5.131a1.69 1.69 0 0 1-.932-1.151 1.673 1.673 0 0 1-.009-.745c.054-.246.163-.476.318-.674a32.698 32.698 0 0 0 6.31-13.734 1.685 1.685 0 0 1 1.655-1.362c5.541.019 9.682 2.042 12.308 6.013a1.706 1.706 0 0 1 .224 1.422 53.48 53.48 0 0 1-6.861 14.759 1.695 1.695 0 0 1-2.148.603z"
          fill="#E5E7E8"
        />
        <path
          d="m134.905 118.755-8.307-3.923a.861.861 0 1 1 .736-1.558l8.307 3.923a.849.849 0 0 1 .444.488.859.859 0 0 1-.032.659.86.86 0 0 1-1.148.411zM136.195 116.022l-8.307-3.922a.866.866 0 0 1-.411-1.148.864.864 0 0 1 1.147-.411l8.307 3.923a.86.86 0 0 1-.077 1.59.861.861 0 0 1-.659-.032z"
          fill="#fff"
        />
        <path
          d="m125.096 30.233-.773.084c-3.448-13.548-10.131-22.935-19.327-27.144-11.69-5.351-26.147-1.758-40.705 10.118-14.633 11.937-27.586 30.791-36.474 53.091l-.75-.343c8.927-22.398 21.947-41.343 36.661-53.346C78.516.629 93.268-2.99 105.264 2.5c9.459 4.33 16.317 13.92 19.832 27.732z"
          fill="#E5E9EB"
        />
        <path
          d="M39.784 47.878a224.923 224.923 0 0 0-5.717 13.118C23.873 86.57 18.708 112.688 19.13 136.528l-.796-.085c-.423-23.929 4.757-50.137 14.982-75.79a225.57 225.57 0 0 1 5.734-13.155l.734.38z"
          fill="#E5E9EB"
        />
        <path
          d="M39.4 65.45a224.893 224.893 0 0 0-5.716 13.118C23.49 104.142 18.325 130.26 18.747 154.1l-.796-.085c-.423-23.928 4.758-50.136 14.983-75.79a225.443 225.443 0 0 1 5.733-13.155l.734.38z"
          fill="#E5E9EB"
        />
        <path
          d="M17.99 71.841c.88-1.323.359-3.218-1.165-4.232-1.524-1.014-3.473-.762-4.353.561-.881 1.324-.36 3.219 1.164 4.233 1.523 1.013 3.473.762 4.353-.562zM205.513 119.643c.88-1.323.359-3.218-1.165-4.232-1.523-1.014-3.472-.762-4.353.561-.881 1.324-.359 3.219 1.164 4.233 1.524 1.013 3.473.762 4.354-.562z"
          fill="#BDC2C5"
        />
      </g>
      <defs>
        <clipPath id="9i7zueo3ua">
          <path fill="#fff" transform="translate(.704)" d="M0 0h246.591v200H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
